export default __webpack_public_path__ + "images/fe7f19a7db8826468bb1e491da8d21d0-jewelry_small.webp";